// @flow

export const impossible = <T>(t: empty): T => {
  throw new Error(`Unknown ${t}`);
};
